<template>
	<section>
		<div class="content">
			<h1>vue-parallax-js</h1>
			<p>
				vue component for parallax effect on elements <br>
				no dependencies <br>
				lightweight <br>
				1.6 KB - minified<br>
				for <span>Vue.js 2</span> <br>
			</p>

			<h2>Setup <a href="#setup" name="setup">~</a></h2>
			<b>install via npm</b>
			<pre>
npm install --save vue-parallax-js
<em># or use yarn</em>
<em># yarn add vue-parallax-js</em>
			</pre>

			<b>using <span>vue-parallax-js</span></b>
			<p>in your main javascript file</p>
			<pre>
<em>// import Vue and vue-parallax-js</em>
import Vue from 'vue'
import VueParallaxJs from 'vue-parallax-js'

<em>// add vue-parallax-js to vue</em>
Vue.use(VueParallaxJs)
			</pre>

			<h2>Usage <a href="#usage" name="usage">~</a></h2>
			<b>in your templates you can now use the <span>v-parallax</span> directive.</b>
			<pre>
{{basicUsageExample[0]}}<span>0.2</span>{{basicUsageExample[1]}}

<em><span>0</span> will appear static on the page (no effect)</em>
<em><span>1</span> will move along the page at the same speed as the scrolling</em>
<em><span>-1</span> will move upwards at the same speed as the scrolling</em>
			</pre>

			<h2>Options <a href="#options" name="options">~</a></h2>
			<p>when adding vue-parallax-js to Vue you can pass some options</p>
			<pre>
Vue.use(VueParallaxJs, <span>{option: value}</span>)
			</pre>
			<div class="option head">
				<div class="param">option</div>
				<div class="type">value-type</div>
				<div class="desc">description</div>
			</div>
			<div class="option">
				<div class="param">minWidth</div>
				<div class="type">integer</div>
				<div class="desc">minumum window width for parallax to take effect</div>
			</div>

			<h2>Modifiers <a href="#modifiers" name="modifiers">~</a></h2>
			<p>when using the <span>v-parallax</span> directive you can also pass some modifiers to configure the instance of vue-parallax-js</p>
			<pre>
{{optioExample[0]}}.<span>modifier</span>{{optioExample[1]}}
<em>// notice the <span>.</span> between "v-parallax" and the modifier</em>
			</pre>

			<div class="option head">
				<div class="param">modifier</div>
				<div class="desc">description</div>
			</div>
			<div class="option">
				<div class="param">centerX</div>
				<div class="desc">will add "transform: <em>translateX(-50%)</em>" along with the parallax positioning</div>
			</div>
			<div class="option">
				<div class="param">absY</div>
				<div class="desc">uses the window height instead of the element height for the calculations</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'content',
	computed: {
		basicUsageExample() {
			return ['<h1 v-parallax="', '">vue-parallax-js</h1>']
		},
		optioExample() {
			return ['<h1 v-parallax', '="0.2">vue-parallax-js</h1>']
		}
	}
}
</script>

<style lang="sass" scoped>

pre
	margin: 5px -3px 30px
	padding: 2px 25px
	border-radius: 0 20px 20px 20px
	background: #fff
	border: 1px solid #ddd
	white-space: pre-wrap

em
	opacity: 0.9
	color: #7929a7

span
	color: #7929a7
	display: inline-block
	padding: 0px 4px
	margin: 2px 0
	border-radius: 5px
	background: transparentize(#7929a7, .8)
	font-weight: bold

h1
	font-size: 180%
	border-bottom: 1px solid #999
	margin-top: 0
h2
	font-size: 160%
	margin: 50px 0 20px
	border-bottom: 1px solid #999

p
	margin-bottom: 5px

a[name]
	text-decoration: none
	color: black
	opacity: 0.05
	position: relative
	padding-top: 20px
	display: inline-block
	&:hover
		opacity: 0.3

.option
	background: #f4f4f4
	display: flex
	border: 1px solid #ddd
	margin-top: -1px

	&.head
		// opacity: 0.7
		text-transform: uppercase
		font-size: 70%

	.param
		padding: 10px 20px
		width: 150px
		color: #7929a7
		background: rgba(255,255,255,1)
		border-right: 1px solid #ddd

	.type
		padding: 10px 20px
		width: 200px
		color: #7929a7
		background: rgba(255,255,255,.3)
		border-right: 1px solid #ddd
		text-align: right

	.desc
		padding: 10px 20px


section
  box-sizing: border-box
  background: #f4f4f4
  padding: 50px 0 100px
  position: relative
  // top: 100vh
  left: 0
  right: 0
  color: black
  font-family: sans-serif
  font-size: 14px

  @media screen and (min-width: 600px)
  	font-size: 16px

.content
  width: 1000px
  max-width: calc(100% - 40px)
  margin: 0 auto
  line-height: 1.5
  color: #333


</style>



// WEBPACK FOOTER //
// content.vue?0c0bc891